import { MetaData, FileInclMetaData } from "../models"
import { Observable, Observer } from 'rxjs/Rx';
export class FileObject {
	private _dataUrl: string
	uniqueFilename: string
	file: File
	metaData: MetaData
	uploadSuccessful: boolean = false
	uploadError: string = null
	type: string;
	image
	constructor() {

	}

	set dataUrl(dataUrl: string) {
		this._dataUrl = dataUrl;
		this.image = new Image();
		this.image.src = this.dataUrl;
		this.createMetaDataDimension()
	}

	private createMetaDataDimension() {
		if (!this.metaData.dimension) {
			this.metaData.dimension = {height: this.image.height, width: this.image.width}
		}
	}

	get dataUrl(): string {
		return this._dataUrl;
	}

	private setDataUrlAsBase64(base64Str: string) {
		this.dataUrl = this.getBase64Prefix() + base64Str;

	}
	private getBase64Prefix() {
		return "data:" + this.metaData.contentType + ";base64,"
	}

	public getFormattedResultion(): string {
		if (this.metaData.dimension)
			return "" + this.metaData.dimension.width + "x" + this.metaData.dimension.height + "px"
		else
			return "N/A"
	}

	public getFormattedFileName(): string {
		return this.metaData.fileName || this.file.name
	}

	public getFormattedFileSize(): string {
		return this.metaData.fileSize + " " + this.metaData.fileSizeUnit
	}
	/*vvv THIS IS DEPRECATED::: DONT USE! vvv*/
	/*vvv THIS IS DEPRECATED::: DONT USE! vvv*/
	/*vvv THIS IS DEPRECATED::: DONT USE! vvv*/
	/*vvv THIS IS DEPRECATED::: DONT USE! vvv*/

	/*Durch das Asynchrone laden der dataurl gibt es große probleme in verwendung mit ngrx und der change-detection in angular

	!!!!Alterantive: fromFileAsync
	*/
	public static fromFile(file: File): FileObject {
		let f = new FileObject()
		f.file = file;
		f.metaData = new MetaData();
		f.uniqueFilename = this.generatePrefix() + "_" + file.name;
		if (FileObject.isSupportedImageType(file.type)) {
			this.createDataUrl(file).subscribe(dataUrl => f.dataUrl = dataUrl);
			f.type = "image"
		} else {
			f.type = this.getFileType(file.type)
		}

		let formattedFileSize = this.calculateFileSize(f)
		f.metaData.fileSize = formattedFileSize.fileSize
		f.metaData.fileSizeUnit = formattedFileSize.fileSizeUnit

		return f;
	}
	/*^^^ THIS IS DEPRECATED::: DONT USE! ^^^*/
	/*^^^ THIS IS DEPRECATED::: DONT USE! ^^^*/
	/*^^^ THIS IS DEPRECATED::: DONT USE! ^^^*/
	/*^^^ THIS IS DEPRECATED::: DONT USE! ^^^*/


	public static fromFileAsync(file: File): Observable<FileObject> {
		return Observable.create((observer) => {
			let f = new FileObject()
			f.file = file;
			f.metaData = new MetaData();
			f.uniqueFilename = this.generatePrefix() + "_" + file.name;

			let formattedFileSize = this.calculateFileSize(f)
			f.metaData.fileSize = formattedFileSize.fileSize
			f.metaData.fileSizeUnit = formattedFileSize.fileSizeUnit

			if (FileObject.isSupportedImageType(file.type)) {
				f.type = "image"
				this.createDataUrl(file).subscribe(dataUrl => {
					f.dataUrl = dataUrl
					observer.next(f)
					observer.complete()
				});
			} else {
				f.type = this.getFileType(file.type)
				observer.next(f)
				observer.complete()
			}
		})

	}

	private static calculateFileSize(fileObject: FileObject): {fileSize: number, fileSizeUnit: string} {
		let fileSize = 0;
		if (fileObject.dataUrl) {
			// 4*(n/3) chars are needed to represent n bytes
			fileSize = 3 * (fileObject.dataUrl.length - fileObject.getBase64Prefix().length) / 4
		}
		if (fileObject.file) {
			fileSize = fileObject.file.size;
		}
		let fileSizeInKiloByte: number = fileSize / 1000
		let fileSizeInMegaByte: number = fileSizeInKiloByte / 1000
		let unit: string;
		let size: number;
		if (fileSizeInMegaByte >= 1) {
			unit = "MB"
			size = Math.round(fileSizeInMegaByte)
		} else {
			unit = "KB"
			size = Math.round(fileSizeInKiloByte)
		}
		return {fileSize: size, fileSizeUnit: unit}
	}

	public static fromMetaData(metaData: MetaData): FileObject {
		let f = new FileObject()
		f.uniqueFilename = this.generatePrefix() + "_" + metaData.fileName;
		f.metaData = metaData;
		return f;
	}

	public static fromFileInclMetaData(fileInclMetaData: FileInclMetaData): FileObject {
		let f = this.fromMetaData(fileInclMetaData.fileMetaData)
		if (FileObject.isSupportedImageType(fileInclMetaData.fileMetaData.contentType)) {
			f.setDataUrlAsBase64(fileInclMetaData.fileAsBase64)
			f.type = "image"
		} else {
			f.type = this.getFileType(fileInclMetaData.fileMetaData.contentType)
		}
		return f;
	}

	private static generatePrefix(): string {
		return (Math.floor((1 + Math.random()) * 999999999).toString(16));
	}

	private static isSupportedImageType(mimeType: string) {
		if (!mimeType) return false;
		if (mimeType === "image/vnd.adobe.photoshop") return false;
		if (mimeType === "image/tiff") return false;
		if (mimeType.indexOf("image/") !== -1) {
			return true;
		}
		return false;
	}

	private static createDataUrl(file: File): Observable<string> {
		return Observable.create((observer: Observer<string>) => {
			let reader: FileReader = new FileReader();
			reader.onload = (e) => {
				observer.next(reader.result)
				observer.complete();
			}
			reader.readAsDataURL(file);
		});
	}

	private static getFileType(mimeType: string) {
		if (mimeType === "application/vnd.oasis.opendocument.text") {
			return "word"
		}
		if (mimeType === "application/zip") {

		}
		if (mimeType === "text/plain") {
			return "text"
		}
		if (mimeType === "application/pdf") {
			return "pdf"
		}
		if (mimeType === "application/gzip") {

		}
		if (mimeType === "application/x-rar") {

		}
		if (mimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
			return "excel"
		}
		if (mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
			return "word"
		}
		if (mimeType === "application/msword") {
			return "word"

		}
		if (mimeType === "application/vnd.ms-excel") {
			return "excel"
		}
		if (mimeType === "application/rtf") {
			return "word"
		}
		if (mimeType === "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
			return "powerpoint"
		}
		if (mimeType === "application/vnd.ms-powerpoint") {
			return "powerpoint"
		}
		return "unknown"
	}
}



// WEBPACK FOOTER //
// ./src/app/models/fileobject.model.ts